import { render, staticRenderFns } from "./Valor-diferenciado-item.vue?vue&type=template&id=ab727dca&scoped=true&"
import script from "./Valor-diferenciado-item.vue?vue&type=script&lang=js&"
export * from "./Valor-diferenciado-item.vue?vue&type=script&lang=js&"
import style0 from "./Valor-diferenciado-item.vue?vue&type=style&index=0&id=ab727dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab727dca",
  null
  
)

export default component.exports